import { AxiosObservable } from '@cbridge-utils/axios-observable';
import { BaseService, ApiServiceType } from '@cbridge-packages/api-base';
import {
  IApiSupersetChartListResponse,
  IApiSupersetExploreResponse,
  IApiSupersetChartDataRequest,
  IApiSupersetChartDataResponse,
} from '../_interfaces/IApiSuperset';

export class SupersetApiService extends BaseService {
  constructor() {
    super(ApiServiceType.Analytics);
    /*this.api = Axios.create({
      baseURL: '/analytics/api/v1',
      headers: { 'Content-Type': 'application/json' },
    });*/
  }

  /**
   * Get list of all available charts
   * GET /api/v1/chart/
   */
  getCharts(): AxiosObservable<IApiSupersetChartListResponse> {
    return this.api.get<IApiSupersetChartListResponse>('/chart');
  }

  /**
   * Get chart metadata (columns, metrics, form_data)
   * GET /api/v1/explore/?slice_id={sliceId}
   */
  getChartMetadata(sliceId: number): AxiosObservable<IApiSupersetExploreResponse> {
    return this.api.get<IApiSupersetExploreResponse>('/explore', {
      params: { slice_id: sliceId },
    });
  }

  /**
   * Get chart data with pagination, filtering, and sorting
   * POST /api/v1/chart/data?form_data={"slice_id":{sliceId}}
   */
  getChartData(
    sliceId: number,
    request: IApiSupersetChartDataRequest,
  ): AxiosObservable<IApiSupersetChartDataResponse> {
    const formDataParam = encodeURIComponent(JSON.stringify({ slice_id: sliceId }));

    return this.api.post<IApiSupersetChartDataResponse>(
      `/chart/data?form_data=${formDataParam}`,
      request,
    );
  }

  /**
   * Export chart data as CSV
   * POST /api/v1/chart/data with result_format: 'csv'
   * Returns a zip file containing CSV data
   */
  exportChartDataCsv(
    sliceId: number,
    request: Omit<IApiSupersetChartDataRequest, 'result_format'>,
  ): AxiosObservable<Blob> {
    const formDataParam = encodeURIComponent(JSON.stringify({ slice_id: sliceId }));

    return this.api.post<Blob>(
      `/chart/data?form_data=${formDataParam}`,
      { ...request, result_format: 'csv' },
      { responseType: 'blob' },
    );
  }
}
